module.exports = __webpack_public_path__ + "img/win_download_btn_en.fa4faa20.svg";